export default "__VITE_ASSET__D2KfUDKr__ 100w";